import React from 'react';
import request from 'arcdynamic-request';
import Alert from '../Alert';
import Control from 'react-control';

function getProduct(filter, count) {
	return request(arc.path.store, {
		service: 'cart',
		action: 'store.product.get',
		schema: '[name,sku]',
		options: {
			filter,
			limit: {
				count: count,
			},
			flag: {
				file: true,
				tag: true,
				attributeValue: true,
			},
		},
	}, {
		expires: 1000*60*60,
	})
}

export default React.createClass({
	_autoComplete(e) {
		const search = e.target.value.trim();

		if (!search) {
			this.setState({
				products: false,
				error: false,
				isBusy: false,
				index: 0,
			})
			return;
		}

		this.setState({
			error: false,
			isBusy: true,
		});

		getProduct({ 
			search, 
		}, 10).then(res => {
			if (this.isMounted()) {
				this.setState({
					products: res.data,
					hasFocus: true,
					isBusy: false,
					error: res.success ? false : res.message,
					index: 0,
				})
			}
		});
	},
	_done(error) {
		if (this.isMounted()) {
			this.setState({
				isBusy: false,
				error,
			});
			this.refs.sku.value = '';
			this.refs.sku.focus();
		}
	},
	_setFocus(e) {
		if (!this.refs.auto || !this.refs.auto.contains(e.target)) {
			this.setState({
				hasFocus: false,
			})
		}
	},
	_keyControls(e) {
		switch (e.key) {
			case 'ArrowDown':
				this.setState({ index: Math.min(this.state.index+1, this.state.products && this.state.products.length ? this.state.products.length - 1 : 0) });
				e.preventDefault();
			break;
			case 'ArrowUp':
				this.setState({ index: Math.max(this.state.index-1,0) });
				e.preventDefault();
			break;
		}
	},
	_save(el) {
		this.setState({ products: false });
		this.refs.sku.value = '';
		this.refs.sku.focus();
		this.props.handleSku(el.sku);
	},
	_handleSubmit(e) {
		e.preventDefault();

		if (this.state.isBusy) return;

		if (this.state.products && this.state.products[this.state.index]) {
			this.props.handleSku(this.state.products[this.state.index].sku);
		}
	},
	getInitialState() {
		return {
			isBusy: false,
			products: false,
			error: false,
			hasFocus: false,
		};
	},
	componentDidMount() {
		document.body.addEventListener('click', this._setFocus)
	},
	componentWillUnmount() {
		document.body.removeEventListener('click', this._setFocus)
	},
	render() {
		const { products, error, isBusy, hasFocus, index } = this.state;

		return (
			<div className='Suggest'>
				<div ref='auto' className='Suggest_auto'>
					<form onSubmit={this._handleSubmit}>
						<input onFocus={()=> this.setState({hasFocus: true})} onChange={this._autoComplete} onKeyDown={this._keyControls} autoFocus ref='sku' placeholder='Product Search' type='text'/>
						<button disabled={isBusy} data-is-busy={isBusy || null} className='Suggest_btn'>Add</button>
					</form>
					{
						Array.isArray(products) && products.length && hasFocus ? (
							<div className='Suggest_auto_list'>
								{
									products.map((el,i) => (
										<Control className={'Suggest_auto_list_item'+(i === index ? ' Suggest_auto_list_item--selected' : '')} key={el.sku} onClick={()=> this._save(el) }>
											{el.name} - SKU: {el.sku}
										</Control>
									))
								}
							</div>
						) : null
					}
				</div>
				<Alert type='error'>{error}</Alert>
			</div>
		);
	},
});
